<template>
  <tg-layout :headerHeight="headerHeight">
    <template slot="header">
      <tg-search-tool :data="request" @on-submit="handleSearch">
        <el-row type="flex" v-show="!isDetail && hasData">
          <tg-button
            round
            border
            hoverBorderOnly
            theme="primary"
            @click.native="handleUserFilter(false)"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-filter"
                :class="{ active: scope.isHover || scope.isFocus }"
              ></i>
            </template>
            {{ $t("component.btn.filter") }}
          </tg-button>
          <tg-button
            v-if="isFiltered"
            :disabled="!canRefresh"
            round
            border
            hoverBorderOnly
            theme="primary"
            @click.native="handleRefreshFiltered"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-reload"
                :class="{ active: scope.isHover || scope.isFocus }"
              ></i>
            </template>
            {{ $t("component.btn.refresh") }}
            <template v-if="!canRefresh">
              (
              <span>{{ nextRefresh }}</span
              >)
            </template>
          </tg-button>
          <tg-button
            icon="reply"
            round
            border
            hoverBorderOnly
            theme="primary"
            @click.native="handleUserFilter(true)"
            :disabled="!isFiltered"
          >
            <template slot="icon" slot-scope="scope">
              <i
                class="tg-icon tg-icon-recovery"
                :class="{ active: scope.isHover || scope.isFocus }"
              ></i>
            </template>
            {{ $t("component.btn.recover") }}
          </tg-button>
        </el-row>
        <el-input
          :placeholder="$t('component.form.input.placeholder.member')"
          v-model="searchData.targetName"
          class="tg-input input-search-username"
          size="small"
          clearable
        ></el-input>
        <!-- 注單項目篩選 全部、實際流水、體驗金 -->
        <template v-if="$store.state.service.merchantCode != 'AA008'" slot="after">
          <tg-radio-button
            :items="betOptions"
            @on-click="handleBetFilter"
            v-model="selectedBetOption"
          ></tg-radio-button>
        </template>
      </tg-search-tool>
      <el-row style="padding:5px;">
        <!-- 平台選擇按鈕 -->
        <third-party-search-btn
          :style="{'display': !showThirdParty ? 'none': 'initial'}"
          @click.native="showThirdPartyCheckBoxDialog"
        ></third-party-search-btn>
        <third-party-platform
          :style="{'display': !showThirdParty ? 'none': 'initial'}"
          v-model="thirdPartyData"
          @on-change="handleSearchOneThirdParty"
        ></third-party-platform>
      </el-row>
      <el-row v-if="showComposed">
        <template v-for="(row, i) in composed">
          <tg-button
            :key="'composed-' + i"
            round
            border
            hoverBorderOnly
            theme="primary"
            :active-gradient="row.value == groupLine"
            @click.native="toggleGroupLine(row)"
          >
          {{ row.item }}
          </tg-button>
        </template>
      </el-row>
      <tg-amount-bar
        ref="amount"
        v-if="showAmount && !showNoData"
        :columns="amountColumns"
        :row="amountTotalData"
      ></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      :sortMethods="sortMethods"
      @on-loaded="handleLoaded"
      :showPagination="isDetail"
      :summary-method="parsePageSummary"
      :showSummary="isDetail"
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name-with-link
          :class="scope.row['betId'] ? '': 'clickable text-primary'"
          :row="scope.row"
          :column="scope.column"
          :token="scope.row['betId'] ? null : generalQueryToken(scope.row)"
          route="accounts.paper.user"
        ></tg-user-full-name-with-link>
      </template>

      <template slot="bet" slot-scope="scope">
        <router-link
          :to="{
            name: 'accounts.paper.bet',
            params: {
              username: scope.row['name'],
              check: true,
            },
            query: {
              token: generalQueryToken(scope.row)
            }
          }"
          >{{ scope.formated }}</router-link
        >
      </template>

      <!-- 平台 -->
      <template slot="source_type" slot-scope="scope">
        <span :class="['text-' +  scope.row.source_type]">
            {{ $t("component.label.source_type." + scope.row.source_type) }}
        </span>
      </template>

      <!-- 單號 -->
      <template slot="betId" slot-scope="scope">
        <tg-bet-id :row="scope.row"></tg-bet-id>
      </template>

      <!-- 賽事內容 -->
      <template slot="betContent" slot-scope="scope">
        <tg-bet-content v-if="scope.row.source_type == 'tg'" :row="scope.row"></tg-bet-content>
        <third-party-saba-bet-content v-else-if="
            ((scope.row.source_type == 'saba' || scope.row.source_type == 'sabawhite_sport') &&
            (scope.row.content_type == 2 || scope.row.content_type == 5))
            || (scope.row.source_type.includes('sport') && scope.row.serial_type == 1) //serial_type == 1 非串關
          "
           :row="scope.row"></third-party-saba-bet-content>
        <third-party-saba-parlay-bet-content v-else-if="(scope.row.source_type == 'saba' || scope.row.source_type == 'sabawhite_sport') && (scope.row.content_type == 3 || scope.row.content_type == 4)" :row="scope.row" @on-click="handlePublicParlayDialog(scope.row)"></third-party-saba-parlay-bet-content>
        <third-party-saba-parlay-bet-content
          v-else-if="
            (scope.row.source_type != 'saba' && scope.row.source_type.includes('sport')) 
          "
          :row="scope.row"
          @on-click="handlePublicParlayDialog(scope.row)"
        ></third-party-saba-parlay-bet-content>
        <third-party-public-bet-content
          v-else
          :row="scope.row"
        ></third-party-public-bet-content>
      </template>
      
      <template slot="deviceInfo" slot-scope="scope">
        <span>{{ scope.row.ip }}</span><br>
      </template>
      
      <template slot="errorcode" slot-scope="scope">
        <!-- 保本 -->
        <span v-if="scope.row.status_id == 1"
          >{{ $t("enum.status_id[1]") }}<br
        /></span>
        <!-- VIP保本 -->
        <span v-if="scope.row.status_id == 2"
          >{{ $t("enum.status_id[2]") }}<br
        /></span>
        <!-- 體驗金注單 -->
        <span v-if="scope.row.errorCode == 1"
          >{{ $t("enum.historyErrorCode[" + scope.row.errorCode + "]") }}<br
        /></span>
        <!-- 智能下單設置編號 -->
        <span v-if="scope.row.smart_no != null">
          {{ $t("component.label.smart_no") + "-" + scope.row.smart_no }}<br />
        </span>
        <!-- 同秒同注單 -->
        <span
          v-if="scope.row.same_type != null && scope.row.same_type < 99"
          :class="{ 'text-red': true }"
        >
          {{ $t("component.label.same_type[" + scope.row.same_type + "]") }}
        </span>
        <!-- 重新结算 (當該注單重新結算時顯示) -->
        <span
          v-if="scope.row.isReCount == 1"
          :class="{ 'text-red': true }"
        >
          {{ $t("component.label.recount") }}
        </span>

        <!-- WM真人 住單【有重對】時顯示【重新結算】 -->
        <span
          v-if="scope.row.content_type == 6 && scope.row.wm_reset == 1"
          :class="{ 'text-red': true }"
        >
          {{ $t("component.label.recount") }}
        </span>
      </template>
    </tg-table>
    <div
      v-if="showNoData"
      class="tg-bg-white"
      style="
        position: absolute;
        z-index: 3;
        width: calc(100vw - 280px);
        height: calc(100vh - 400px);
      "
    >
      <tg-nodata></tg-nodata>
    </div>

    <!-- 沙巴串關詳情 -->
    <third-party-saba-detail-dialog
      ref="sabaParlayMatchs"
    ></third-party-saba-detail-dialog>
    <!-- 沙巴串關結果 -->
    <third-party-saba-result-dialog
      ref="sabaParlayResult"
    ></third-party-saba-result-dialog>

    <!-- 平台篩選彈窗 -->
    <third-party-check-box-dialog
      ref="thirdPartyCheckBoxDialog"
      :third_party="thirdPartyData"
      @on-click="handleSearchThirdParty"
      isNotAccount
    ></third-party-check-box-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgTable from "@/components/table/TgTable";
import TgUserFullNameWithLink from "@/components/slot/TgUserFullNameWithLink";
import TgButton from "@/components/button/TgButton";
import TgBetContent from "@/components/slot/TgBetContent";
import TgBetId from "@/components/slot/TgBetId";
import TgAmountBar from "@/components/amount/TgAmountBar";
import ThirdPartySabaBetContent from "@/components/slot/ThirdPartySabaBetContent";
import ThirdPartySabaParlayBetContent from "@/components/slot/ThirdPartySabaParlayBetContent";
import ThirdPartySabaDetailDialog from "@/components/dialog/ThirdPartySabaDetailDialog";
import ThirdPartySabaResultDialog from "@/components/dialog/ThirdPartySabaResultDialog";
import ThirdPartyPublicBetContent from "@/components/slot/ThirdPartyPublicBetContent";
import ThirdPartyCheckBoxDialog from "@/components/dialog/ThirdPartyCheckBoxDialog";
import ThirdPartySearchBtn from "@/components/button/ThirdPartySearchBtn";
import ThirdPartyPlatform from '@/components/tool/ThirdPartyPlatform';

import str from "@/utils/str";
import apis from "@/apis";
import TgRadioButton from "@/components/button/TgRadioButton.vue";
import TgNodata from "@/components/TgNodata.vue";
import { summary } from "@/utils/table";
import {sabaParlayHandler} from "@/mixins/betContent";
import {thirdPartyCheckBoxDialogHandler} from "@/mixins/third_party/dialog";

const api = apis.accounts.paper;

export default {
  components: {
    TgLayout,
    TgSearchTool,
    TgTable,
    TgUserFullNameWithLink,
    TgButton,
    TgBetContent,
    TgBetId,
    TgAmountBar,
    TgRadioButton,
    TgNodata,
    ThirdPartySabaBetContent,
    ThirdPartySabaParlayBetContent,
    ThirdPartySabaDetailDialog,
    ThirdPartySabaResultDialog,
    ThirdPartyPublicBetContent,
    ThirdPartyCheckBoxDialog,
    ThirdPartySearchBtn,
    ThirdPartyPlatform
  },
  mixins: [sabaParlayHandler,thirdPartyCheckBoxDialogHandler],
  data() {
    return {
      columns: [],
      amountPageData: {},
      amountTotalData: {},
      proxy: api.getData,
      searchData: {
        users:"",
        // 保留，輸入框使用
        targetName:"",
        third_party:[],
      },
      isFiltered: false,
      canRefresh: true,
      nextRefresh: 0,
      groupTag: "",
      upperGroupTag: "",
      clicked: null,
      isDetail: false,
      showAmount: false,
      hasData: false,
      showNoData: false,
      sortMethods: {
        quantity: this.sortData("quantity"),
        dealmoney: this.sortData("dealmoney"),
      },
      lastSelectedUsers: [],
      composed: [],
      groupLine: '',
      showComposed: false,
    };
  },
  props: {
    username: String,
    betOption: Number,
    third_party: Array,
    invoke: String,
  },
  created() {
    if (this.username) {
      this.clickedUser = this.username;
      this.targetName = this.username;
    }

    if (this.betOption) {
      this.selectedBetOption = this.betOption;
    }

    if (this.third_party) {
      this.platforms = this.third_party;
      
      this.thirdPartyData = this.thirdParties.filter(element => {
        return this.third_party.find(x=>x === element.platform) != undefined;
      });
    }

    if (this.$route.params.invoke == 'menu') {
      this.initRequest();
    }

    if(this.$route.params.username && this.$route.query.token) {
      let token = JSON.parse(str.decrypt(this.$route.query.token));
      this.$store.commit('pages/accounts/paper/update_search', {
        third_party: token.third_party,
        users: token.users,
        betOption: token.betOption,
        groupLine: token.groupLine
      });
      // 將帶過來的平台參數丟給元件
      this.thirdPartyData = this.thirdPartyData.filter(x => {
          return token.third_party.indexOf(x.platform) !== -1;
      })
    }

    this.$store.dispatch("pages/accounts/paper/fetchColumns").then(() => {
        this.$nextTick(() => {
          this.$refs.table.init(this.request);
        });
    });
  },
  computed: {
    // 頁面資料儲存庫
    store () {
      return this.$store.state.pages.accounts.paper;
    },
    normalColumns() {
      return this.store.normalColumns;
    },
    detailColumns() {
      return this.store.detailColumns;
    },
    amountColumns() {
      return this.isDetail ? this.store.detailAmountColumns : this.store.amountColumns;
    },
    betOptions() {
      return this.store.betFilters;
    },
    clickedUser: {
      get() {
        return this.store.clickedUser;
      },
      set(val) {
        this.$store.commit('pages/accounts/paper/update', {clickedUser: val});
      }
    },
    request() {
      return {...this.store.searchData, groupLine: this.groupLine}
    },
    targetName: {
      get() {
        return this.store.searchData.targetName;
      },
      set(val) {
        this.$store.commit('pages/accounts/paper/update_search', {targetName: val});
      }
    },
    selectedBetOption: {
      get() {
        return this.store.searchData.betOption;
      },
      set(val) {
        this.$store.commit('pages/accounts/paper/update_search', {betOption: val});
      }
    },
    platforms: {
      get() {
        return this.store.searchData.third_party;
      },
      set(val) {
        this.$store.commit('pages/accounts/paper/update_search', {third_party: val});
      }
    },
    thirdPartyData: {
      get() {
        return this.store.thirdPartyData;
      },
      set(val) {
        this.$store.commit('pages/accounts/paper/update', {thirdPartyData: val});
      }
    },
    filteredUsers: {
      get() {
        return this.store.searchData.users;
      },
      set(val) {
        this.$store.commit('pages/accounts/paper/update_search', {users: val});
      }
    },
    headerHeight() {
      return !this.showAmount ? 110 : 170;
    },
    parsePageSummary() {
      let data = this.amountPageData ? [this.amountPageData] : [];

      return () => {
        return summary(
          this.detailColumns,
          data,
          this.$t("component.table.summary"),
          (this.isDetail)?4:1
        );
      };
    },
  },
  methods: {
    handleSearch() {
      this.clickedUser = null;
      this.isFiltered = false;
      this.searchData.users = null;
      this.targetName = this.searchData.targetName;
      this.groupLine = '';
      this.composed = [];
      this.showComposed = false;

      this.$store.commit("breadcrumb/clear");
      if (this.$route.params.username) {
        this.$router.push({ name: "accounts.paper" });
      } else {
        this.$refs.table.search(this.request);
      }
    },
    handleLoaded(response) {
      if(response.retcode == 0){
        this.isDetail = response.is_detail;
        this.groupTag = response.groupTag;
        this.upperGroupTag = response.upperGroupTag;
        this.hasData = response.data.length > 0;
        this.showAmount =
          response.data.length > 0 && !("length" in response.amount_data);
        this.amountPageData = response.amount_page;
        this.amountTotalData = response.amount_data;
        this.composed = JSON.parse(JSON.stringify(response.composed));
        this.groupLine = response.groupLine;
        this.showComposed = response.composed.length > 1;

        let columns = JSON.parse(
          JSON.stringify(
            response.is_detail ? this.detailColumns : this.normalColumns
          )
        );

        if (columns.length > 0) {
          if (response.is_detail) {
            columns[0].langKey = "l10_account";
          } else {
            columns[1].langKey = response.groupTag
              ? response.groupTag + "_account"
              : "userfullname";
          }
        }

        this.columns = columns;

        this.$nextTick(() => {
          if (this.clickedUser) {
            this.addBreadcrumb(response.is_detail);
          } else {
            this.$store.commit("breadcrumb/clear");
          }
        });
      }
    },
    addBreadcrumb(isDetail) {
      let title = str.format(
        "{0} ({1})",
        this.$t("column." + this.upperGroupTag),
        this.clickedUser
      );

      if (isDetail) {
        title = this.clickedUser;
      }
      this.$store.commit("breadcrumb/add", {
        id: "accounts.paper.user_" + this.clickedUser,
        name: "accounts.paper.user",
        query: {
          ...this.$route.query,
        },
        params: {
          username: this.clickedUser,
          betOptions: this.betOptions,
          third_party: this.platforms,
        },
        meta: {
          title: title,
        },
      });
    },
    sortData(column) {
      return (a, b) => {
        return a[column] - b[column];
      };
    },
    handleUserFilter(reset) {
      let ElTable = this.$refs.table.$refs.ElTable;

      let selected;

      if (reset) {
        
        selected = this.lastSelectedUsers;

        this.isFiltered = false;
      } else {
        selected = ElTable.store.states.selection.map((x) => x.name);
        
        if (selected.length == 0) {
          return;
        }

        this.lastSelectedUsers = [...this.filteredUsers];
        this.isFiltered = true;
      }

      this.selectedUsers = selected;

      this.$nextTick(() => {
        let request = { ...this.request };
        request.users = this.selectedUsers;
        this.$refs.table.search(request);
      });
      // ElTable.store.execSort();
    },
    handleRefreshFiltered() {
      if (!this.canRefresh) {
        return;
      }
      let request = { ...this.request };
      request.users = this.selectedUsers;
      this.$refs.table.search(request);
      this.intervalRefreshTime();
    },
    intervalRefreshTime() {
      this.nextRefresh = 60;
      this.canRefresh = false;

      setInterval(() => {
        this.nextRefresh--;

        if (this.nextRefresh <= 0) {
          this.canRefresh = true;
        }
      }, 1000);
    },
    handleUserClick(row, column) {
      this.clickedUser = row[column.name];
      this.clicked = row;
      this.isFiltered = false;
      this.filteredUsers = [];
      this.lastSelectedUsers = [];

      let route = "accounts.paper.user";

      this.$nextTick(() => {
        this.$router.push({
          name: route,
          params: {
            ...this.request,
            username: row[column.name],
          },
          query:{
            token:this.token
          }
        });
      })
    },
    setUserToken(row, column){
      return location.origin +location.pathname+this.$router.resolve({ name: "accounts.paper.user",  params: {username: row[column.name]}});
    },
    initRequest() {
      this.targetName = '';
      let thirdPartyData = [{ platform: "tg", category: 0 }, ...this.thirdParties.filter(element => {
        return element.functional['1000'] == 1;
      })];
      let platforms = thirdPartyData.map(x => x.platform);
      this.selectedBetOption = 0;
      this.thirdPartyData = thirdPartyData;
      this.platforms = platforms;
      this.groupLine = '';
      this.clickedUser = null;
      this.$store.commit("breadcrumb/clear");
    },
    togglePage(hasUser, route) {
      if (route.params.invoke == 'menu') {
        this.initRequest();
      }

      let request = { ...this.request };

      if (route.query.token) {
        let query = JSON.parse(str.decrypt(route.query.token));
        request = {...request, ...query};
      }

      if (hasUser) {
        this.clickedUser = route.params.username;
        request.targetName = route.params.username;
        this.targetName = route.params.username;
        this.$refs.table.search(request);
      } else {
        this.$store.commit("breadcrumb/clear");
        this.clickedUser = null;
        this.groupLine = request.groupLine = '';
        this.$refs.table.init(request);
      }
    },
    handleBetFilter() {
        let request = { ...this.request };

        request.users = this.selectedUsers;
        this.$refs.table.search(request);
        return;
    },
    handleSearchThirdParty(value) {
      this.thirdPartyData = value;

      this.platforms = this.thirdPartyData.map(r => {
        return r.platform;
      });

      this.$nextTick(() => {
        let request = {...this.request};

        if(this.$route.params.username){
          request.targetName = this.$route.params.username;
        }

        // if (this.betOption) {
        //   request.betOption = this.betOption;
        //   this.selectedBetOption = this.betOption;
        // }
        this.$refs.table.search(request);
      });
    },
    handleSearchOneThirdParty(value) {
      this.thirdPartyData = value;

      this.request.third_party = [this.thirdPartyData[0].key];


      this.$nextTick(() => {
        let request = {...this.request};
      
        if(this.$route.params.username){
          request.targetName = this.$route.params.username;
        }
      
        this.$refs.table.search(request);
      });
    },
    generalQueryToken(row) {
      let groupLine = row.group == 10 ? this.groupLine : (this.groupLine + '-' + row.group + ':' + row.id);
      
      return str.encrypt(JSON.stringify({
        ...this.request,
        groupLine: groupLine
      }));
    },
    toggleGroupLine(row) {
      let request = {...this.request};
      request.groupLine = row.value;
      this.$refs.table.search(request);
    }
  },
  watch: {
    username(val) {
      this.togglePage(val, this.$route);
    },
    showAmount() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.invoke) {
      this.targetName = '';
      this.togglePage('', to);
    }

    next();
  },
};
</script>
